import React from 'react';
import ModernHeader from '../components/ModernHeader';
import Footer from '../components/Footer';
import { useSettings } from '../context/SettingsContext';

const RefundPolicy = () => {
  const { settings } = useSettings();
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
      <ModernHeader tenant={{ name: 'Tiket Jini' }} />
      <div style={{ maxWidth: '800px', margin: '0 auto', background: 'white', borderRadius: '20px', padding: '40px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', marginTop: '40px', marginBottom: '40px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src="/Logo1.png" alt="Tiket Jini" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '20px' }} />
          <h1 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#2d3748', marginBottom: '10px' }}>Refund Policy</h1>
          <p style={{ color: '#64748b', fontSize: '1.1rem' }}>Last updated: December 2024</p>
        </div>

        <div style={{ lineHeight: '1.8', color: '#4a5568' }}>
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>1. General Policy</h2>
            <p>All ticket sales are final and non-refundable unless specifically stated otherwise or in cases covered by this refund policy.</p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>2. Eligible Refund Scenarios</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li><strong>Event Cancellation:</strong> Full refund if the venue cancels the event</li>
              <li><strong>Technical Issues:</strong> Refund if booking fails due to our system errors</li>
              <li><strong>Duplicate Bookings:</strong> Refund for accidental duplicate transactions</li>
              <li><strong>Force Majeure:</strong> Natural disasters, government restrictions, or emergencies</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>3. Refund Timeline</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li><strong>Cancellation by Venue:</strong> 24 hours before event - Full refund</li>
              <li><strong>Customer Cancellation:</strong> 48 hours before event - 50% refund (if applicable)</li>
              <li><strong>No-show:</strong> No refund for unused tickets</li>
              <li><strong>Processing Time:</strong> 5-7 business days after approval</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>4. Non-Refundable Situations</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Change of mind or personal circumstances</li>
              <li>Weather conditions (unless venue closes)</li>
              <li>Traffic or transportation issues</li>
              <li>Failure to arrive on time</li>
              <li>Violation of venue rules resulting in ejection</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>5. Refund Process</h2>
            <ol style={{ paddingLeft: '20px' }}>
              <li>Contact our support team with your booking ID</li>
              <li>Provide reason for refund request</li>
              <li>Submit any required documentation</li>
              <li>Wait for review and approval (2-3 business days)</li>
              <li>Refund processed to original payment method</li>
            </ol>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>6. Partial Refunds</h2>
            <p>In some cases, partial refunds may be offered:</p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Service disruptions affecting experience quality</li>
              <li>Facility closures during visit</li>
              <li>Significant delays or operational issues</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>7. Contact for Refunds</h2>
            <p>To request a refund, please contact us with your booking details:</p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Email: refunds@tiketjini.com</li>
              <li>Phone: {settings.supportPhone}</li>
              <li>Include: Booking ID, reason, and supporting documents</li>
            </ul>
          </section>
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            ← Back to Home
          </button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default RefundPolicy;